import {Component} from '@angular/core';
import {UserService} from "../../../../@shared/services/user.service";
import {MatDialog} from "@angular/material/dialog";
import {CheckUserSteamComponent} from "./check-user-steam/check-user-steam.component";

@Component({
  selector: 'app-market',
  templateUrl: './market.component.html',
  styleUrls: ['./market.component.scss']
})
export class MarketComponent {
  public navLinks: any[];

  constructor(private userService: UserService,
              private dialog: MatDialog) {
    this.navLinks = [
      {
        label: 'Steam предметы',
        link: './steam-inventory',
      },
      {
        label: 'Предметы на пополнении ',
        link: './refill-items',
      },
      {
        label: 'Ставки',
        link: './bids',
      }
    ];
  }

  public openCheckUserSteam(): void {
    const params = {
      width: '500px',
      height: 'fit-content',
    }
    this.dialog.open(CheckUserSteamComponent, params)
  }

}
